import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { getApp, initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { getAuth, indexedDBLocalPersistence, initializeAuth, provideAuth } from "@angular/fire/auth";
import { getDatabase, provideDatabase } from "@angular/fire/database";

// import { provideFirebaseApp, getApp, initializeApp, FirebaseApp } from '@angular/fire/app';
// import { provideAuth, initializeAuth } from '@angular/fire/auth';
// import { indexedDBLocalPersistence } from 'firebase/auth';

// import { AngularFireAnalyticsModule, ScreenTrackingService, CONFIG } from "@angular/fire/analytics";
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from "@angular/fire/storage";
import { firebaseConfig } from "../environments/environment";

import { HttpClient, HttpClientModule } from "@angular/common/http";
import { getFirestore, provideFirestore } from "@angular/fire/firestore";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ComponentsModule } from './components/components.module';
import { PipesModule } from "./pipes/pipes.module";
import { AuthenticationService } from "./services/authentication/authentication.service";
import { ContextService } from "./services/context/context.service";
import { DataService } from "./services/data/data.service";
import { ExcelService } from "./services/excel/excel.service";
import { FileService } from "./services/file/file.service";
import { NotificationService } from "./services/notification/notification.service";

export function LanguageLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        // provideFirebaseApp(() => initializeApp(firebaseConfig)),
        provideAuth(() => initializeAuth(getApp(), { persistence: indexedDBLocalPersistence })), // essential or does not work on iPhone
        provideFirebaseApp(() => initializeApp(firebaseConfig)),
        provideFirestore(() => getFirestore()),
        provideAuth(() => getAuth()),
        provideDatabase(() => getDatabase()),
        provideStorage(() => getStorage()),
        provideFunctions(() => getFunctions(getApp(), 'europe-west1')),
        // AngularFireAnalyticsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: LanguageLoader,
                deps: [HttpClient]
            }
        }),
        PipesModule,
        ComponentsModule,
        IonicModule.forRoot(),
        AppRoutingModule,
    ],
    providers: [
        DataService,
        ExcelService,
        NotificationService,
        //TranslateConfigService,
        FileService,
        ContextService,
        AuthenticationService,
        // ScreenTrackingService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        // {
        //     provide: CONFIG,
        //     useValue: {
        //         send_page_view: false,
        //         allow_ad_personalization_signals: false,
        //         anonymize_ip: true
        //     }
        // },
        // { provide: REGION, useValue: "europe-west1" }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
